export const BalanceStore = {
    namespaced: true,
    state:{
        balanceAll: [],
        balanceByUser: {},
    },
    mutations:{
        setBalanceAll(state: any, response: any){
            state.balanceAll = response;
        },
        setBalanceByUser(state: any, response: any){
            state.balanceByUser = response;
        }
    },
    actions:{
        setBalanceAll(context: any, response: any){
            context.commit('setBalanceAll', response);
        },
        setBalanceByUser(context: any, response: any){
            context.commit('setBalanceByUser', response);
        }
    },
    getters:{
        getBalanceAll: (state: any) => state.balanceAll,
        getBalanceByUser: (state: any) => state.balanceByUser
    }
}